import { render } from "./OnboardingMaster.vue?vue&type=template&id=477ec4be&scoped=true"
import script from "./OnboardingMaster.vue?vue&type=script&lang=js"
export * from "./OnboardingMaster.vue?vue&type=script&lang=js"

import "./OnboardingMaster.vue?vue&type=style&index=0&id=477ec4be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477ec4be"]])

export default __exports__